import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { FeatherModule } from 'angular-feather';
import { TablerIconsModule } from 'angular-tabler-icons';
import { ToastrService } from 'ngx-toastr';
import Swal, { SweetAlertResult } from 'sweetalert2';
import { MaterialModule } from '../../material.module';
import { ADCreateUserModel } from '../../Data/Models/ADCreateUserModel/adcreate-user-model';
import { UsermanagementService } from '../../services/apps/usermanagement/usermanagement.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfigurationService } from '../../Configuration/configuration.service';
import { AuthConfigService } from '../../Configuration/auth-config.service';
import { InputRestrictionDirective } from '../../Directives/input-restriction.directive';


@Component({
  selector: 'app-credentials',
  imports: [MaterialModule, TablerIconsModule, FeatherModule, CommonModule, RouterLink, ReactiveFormsModule, FormsModule, InputRestrictionDirective],
  templateUrl: './credentials.component.html',
  styleUrl: './credentials.component.scss'
})
export class CredentialsComponent implements OnInit {

  _disableCreate: boolean = false;
  LinkValidationMessage: string;
  fullEncodedUrl: string;
  @ViewChild("ValidationModel") ValidationModel!: TemplateRef<any>;
  dialogRef: MatDialogRef<any>
  constructor(private route: ActivatedRoute, private router: Router, private dialog: MatDialog, private toastr: ToastrService, private _UsermanagementService: UsermanagementService, private configService: ConfigurationService, private Auth: AuthConfigService) {

  }
  ngOnInit(): void {
    debugger
    this.CreatePassForm()
    var curentdate = new Date();
    var y = curentdate.getFullYear();
    this.year = y
    this.nextyear = y;
    this.route.queryParams.subscribe(params => {
      this.EmailId = params['EmailId'];
    });
    const fullEncodedUrl = encodeURIComponent(window.location.origin + window.location.pathname + window.location.search);
    this.fullEncodedUrl = fullEncodedUrl
    this.btnText = this.fullEncodedUrl.includes("create") ? "Create Password" : "Reset Password"
    this.headerText = this.fullEncodedUrl.includes("create") ? "Let's secure your account with a password" : "Hello, reset your password"
    this.CheckLinkExpiredorUsed();
  }
  type: boolean = true;
  confirmtype: boolean = true;
  mincolor: any;
  speccolor: any;
  numcolor: any;
  uccolor: any;
  lccolor: any;
  incolor: any;
  EmailId: string
  selectedAgent: boolean = false;
  selectedIndividual: boolean = false;
  PasswordForm: FormGroup
  inputType: string = 'password';
  inputTypeCP: string = 'password';
  year: any; nextyear: any;
  btnText: string;
  headerText: string;
  CreatePassForm() {
    this.PasswordForm = new FormGroup({
      Password: new FormControl(null, { validators: Validators.compose([Validators.minLength(8), Validators.required, Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@£$!%^&*?\/#()-+-_'“”":;.,{}[]|])[A-Za-z\d@£$!%^&*?\/&#()-+-_'“”":;.,{}[]|]{8,}$/)]), updateOn: 'blur' }),
      ConfirmPassword: new FormControl(null, Validators.required)
    })
  }
  toggleInputType(Type: string): void {
    if (Type == 'Password') {
      if (!this.PasswordForm.controls["Password"].disabled) {
        this.inputType = this.inputType === 'password' ? 'text' : 'password';
      }
    } else {
      this.inputTypeCP = this.inputTypeCP === 'password' ? 'text' : 'password';
    }
  }
  OnPasswordChange(val: string) {
    debugger;
    if (val.length >= 8)
      this.mincolor = "#00c400";
    else
      this.mincolor = "#000";
    if (/[a-z]/.test(val))
      this.lccolor = "#00c400"
    else
      this.lccolor = "#000"
    if (/[A-Z]/.test(val))
      this.uccolor = "#00c400"
    else
      this.uccolor = "#000"
    if (/[0-9]/.test(val))
      this.numcolor = "#00c400"
    else
      this.numcolor = "#000"
    if (/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(val))
      this.speccolor = "#00c400"
    else
      this.speccolor = "#000"

    if (this.speccolor == "#00c400" && this.uccolor == "#00c400" && this.lccolor == "#00c400" && this.numcolor == "#00c400")
      this.incolor = "#00c400"
    else
      this.incolor = "#000";
    this.ConfirmPasswordChange(val)

  }
  CreatePassword() {
    debugger
    this.PasswordForm.markAllAsTouched();
    this.ConfirmPasswordChange()
    if (this.PasswordForm.valid) {
      this._disableCreate = true
      var model = new ADCreateUserModel();
      model.Email = this.EmailId
      model.Password = this.PasswordForm.controls['Password'].value
      model.link = window.location.href
      this._UsermanagementService.CreatePassword(model).subscribe((data: { message: string }) => {
        this._disableCreate = false
     
        if (data.message == "Successfully created or updated user credential.") {
          var msg = this.fullEncodedUrl.includes("create") ? "Created" : "Set"
          this.toastr.success(`Password ${msg} Successfully`)
          setTimeout(() => {
            localStorage.clear();
            sessionStorage.clear();
            var url = this.configService.get().url
            window.location.href = url
          }, 3000)
        }
          else {
            this.toastr.error(data.message)
          }
      }, (error: HttpErrorResponse) => {
        this._disableCreate = false
        this.toastr.error(error.statusText)
      })
    }
  }
  CheckLinkExpiredorUsed() {
    this._UsermanagementService.CheckLinkExpiredorUsed(this.fullEncodedUrl).subscribe((data: { message: string; }) => {
      if (data.message != 'Link is valid') {
        this.LinkValidationMessage = data.message;
        this.openModal()
      }
    })
  }
  openModal() {
    debugger
    this.dialogRef = this.dialog.open(this.ValidationModel, { disableClose: true })
  }
  closeModal() {
    if (this.dialogRef) {
      this.dialogRef.close()
    }
  }
  OK() {
    this.closeModal()
    window.location.href = 'https://www.andica.com';
  }
  ConfirmPasswordChange(val?:any) {
    debugger
    let pass = val ?val:this.PasswordForm.controls['Password'].value
    let confirmpass = this.PasswordForm.controls['ConfirmPassword'].value
    console.log(pass)
    console.log(confirmpass)
    if (pass && confirmpass && pass.toString().length > 0 && confirmpass.toString().length > 0) {
      if (pass !== confirmpass) {
        this.PasswordForm.controls['ConfirmPassword'].setErrors({ 'match': true })
      } else {
        this.PasswordForm.controls['ConfirmPassword'].setErrors(null)
        this.PasswordForm.controls['ConfirmPassword'].markAsPristine()
      }
    }
  }
}
